import EventEmitter from 'EventEmitter';

const events = {
  OPEN_MODAL: '@assignment-map/OPEN_MODAL',
  CLOSE_MODAL: '@assignment-map/CLOSE_MODAL',
};

const AssignmentMapEventEmitter = new EventEmitter();

export default AssignmentMapEventEmitter;
export { events };
